/* eslint-disable no-unused-vars */
import * as d3 from 'd3';
import _ from 'lodash';
import { swoopyDrag } from '../swoopy-drag';
import { wordwrap } from 'd3-jetpack';
import { intcomma, apmonth, apdate } from 'journalize';
import * as moment from 'moment';
import data from '../../../data/data.json';

export function customDateFormat(d) {
  let year = moment(d).format('YYYY');
  return `${year}`;
}

export function customMobileDateFormat(d, i) {
  let month = moment(d).format('MMM'),
    year = moment(d).format('YYYY');

  if (i % 2 == 0) return `${year}`;
  else return '';
}

// function for creating sales tax revenue chart
function render() {
  // a reference to the default graphic container, change if needed
  const container = d3.select('#sales-tax-revenue-chart');

  // a helper function to grab the container's width
  const getFrameWidth = () => container.node().offsetWidth;

  // a helper function to clear the container of its contents
  const clearContainer = () => container.html('');

  clearContainer();

  //set margins
  let margin = {
    top: 15,
    left: 50,
    bottom: 40,
  };

  let breakPoint = 500;

  // grab the data we need
  let rateData = data.sales_tax_revenues;

  const latest_month = rateData.slice(-1)[0].calendar_date;

  // changing to moment date+time objects
  rateData.forEach(d => (d.date = moment(d.calendar_date, 'MMMM YYYY')));

  // grabbing totals and ranges
  let dateRange = d3.extent(rateData, d => d.date),
    totalsMax = d3.max(rateData, d => d.value);

  // set x scale
  let x = d3.scaleTime().domain(dateRange);

  // set y scale
  let y = d3
    .scaleLinear()
    .domain([0, totalsMax])
    .nice();

  // append svg
  let svg = container.append('svg'),
    g = svg.append('g').attr('class', 'unemployment-rate-line-chart');

  let xAxis = g.append('g').attr('class', 'axis axis--x'),
    yAxis = g.append('g').attr('class', 'axis axis--y');

  let bars = g
    .selectAll('.bar')
    .data(rateData)
    .enter()
    .append('rect')
    .attr('class', 'bar')
    .attr('fill', function(d) {
      if (d.calendar_date == latest_month) {
        //automate this conditional
        return '#529aad';
      }
      return '#a0d1de';
    });

  let labels = g.append('g').attr('class', 'labeled-elements');

  let labelElements = labels
    .selectAll('g')
    .data(getLabeledData(rateData, ['']))
    .enter()
    .append('g')
    .attr('class', 'label-element');

  let labelText = labelElements.append('g').attr('class', 'label-text');

  labelText
    .append('text')
    .text(d => `$${parseFloat((d.value / 1000000000).toFixed(1))} billion`) //automate
    .attr('font-weight', 700);

  let dateAnno = labelText.append('text');

  let frameWidth = getFrameWidth(),
    frameHeight;

  if (frameWidth > breakPoint) {
    frameHeight = 400;
    margin.right = 110; //15
  } else {
    frameHeight = 275;
    margin.right = 85;
    margin.left = 35;
  }

  let chartWidth = frameWidth - margin.left - margin.right,
    chartHeight = frameHeight - margin.bottom;

  svg.attr('width', frameWidth).attr('height', frameHeight);
  g.attr('width', chartWidth).attr(
    'transform',
    `translate(${margin.left},${margin.top})`
  );

  x.range([0, chartWidth]);

  y.range([chartHeight, 0]);

  xAxis
    .call(
      d3
        .axisBottom(x)
        .ticks(5)
        .tickFormat(
          frameWidth < breakPoint ? customMobileDateFormat : customDateFormat
        )
    )
    .attr('transform', `translate(0,${frameHeight - margin.bottom})`);

  yAxis.call(
    d3
      .axisLeft(y)
      .ticks(3)
      .tickSize(-chartWidth)
      .tickFormat(d => {
        if (d == 0) return '';
        else
          return d3
            .format('$~s')(d)
            .replace(/G/, 'B');
      })
      .tickPadding(10)
  );

  bars
    .attr('width', chartWidth / rateData.length)
    .attr('x', d => x(d.date) - chartWidth / rateData.length / 2)
    .attr('y', d => y(d.value))
    .attr('height', d => chartHeight - y(d.value));

  labelElements
    .attr('transform', d => `translate(${x(d.date)},${y(d.value)})`)
    .attr('font-size', frameWidth > breakPoint ? '13px' : '12px');

  labelText
    .attr('transform', (d, i) => {
      if (i === 0 && frameWidth < breakPoint) {
        return 'translate(9, 0)';
      } else return 'translate(9, 0)';
    })
    .attr('text-anchor', 'start');

  dateAnno.attr('y', frameWidth > breakPoint ? 17 : 13);

  dateAnno.each(function(d) {
    d3.select(this)
      .text('')
      .attr('font-weight', d.weight)
      .tspans(
        wordwrap(`in ${d.calendar_date}`, frameWidth > breakPoint ? 15 : 10)
      );
  });
}

function getLabeledData(data, dates) {
  // always annotate the latest datapoint
  let labeledData = [data[data.length - 1]];
  dates.forEach(date => {
    date = moment(date, 'YYYY MMM'); // format needs to match date format in the data
    let foundData = data.find(d => d.date.isSame(date));
    if (foundData) {
      labeledData.push(foundData);
    }
  });
  return labeledData;
}

export default render;
